// extracted by mini-css-extract-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Photo-absolute-center","actions":"onfido-sdk-ui-Photo-actions","btn":"onfido-sdk-ui-Photo-btn"};